import { useTranslation } from "react-i18next";
import { Explanation, Prompt } from "./shared";
import type { QuestionRendererProps } from "./types";

const PROMPT_KEYS = ["question", "prompt", "statement", "front", "scenario", "proposition"];

/** Fallback for question types without a first-class web renderer yet (mirrors
 *  iOS AnyQuestion.unknown). Shows whatever prose the content carries and is
 *  self-graded so the session keeps flowing. */
export function UnknownRenderer({ type, content, revealed }: QuestionRendererProps) {
  const { t } = useTranslation();
  const promptKey = PROMPT_KEYS.find((k) => typeof content[k] === "string");
  const prompt = (promptKey && (content[promptKey] as string)) || t("Review this item");
  const explanation = typeof content.explanation === "string" ? content.explanation : undefined;
  const back = typeof content.back === "string" ? content.back : undefined;

  return (
    <div>
      <Prompt>{prompt}</Prompt>
      <p className="mt-2 inline-block rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-700">
        {t("This question type ({{type}}) isn't fully interactive on web yet — review and self-mark.", {
          type,
        })}
      </p>
      {revealed && back && (
        <div className="mt-4 whitespace-pre-wrap rounded-xl bg-brand-50 p-4 text-ink">{back}</div>
      )}
      {revealed && <Explanation text={explanation} />}
    </div>
  );
}
